import React from "react";

const About = () => {
    return (
        <div className="container">

            <div>
                <h1>About</h1>
            </div>
        </div>
    );
}
export default About;